const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const resolveImageSrc = (url) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('//')) return `https:${url}`;
  return `${API_BASE}${url.startsWith('/') ? url : `/${url}`}`;
};

export const extractImagesFromHtml = (html) => {
  if (!html || typeof html !== 'string') return [];
  const urls = [];
  const re = /<img[^>]+src=["']([^"']+)["']/gi;
  let match = re.exec(html);
  while (match) {
    const url = String(match[1] || '').trim();
    if (url && !urls.includes(url)) urls.push(url);
    match = re.exec(html);
  }
  return urls;
};

export const buildProductGallery = (product) => {
  if (!product) return [];

  const images = [];
  const add = (url) => {
    const value = String(url || '').trim();
    if (value && !images.includes(value)) images.push(value);
  };

  if (Array.isArray(product.images)) {
    product.images.forEach(add);
  }

  add(product.image_url);

  if (Array.isArray(product.image_urls)) {
    product.image_urls.forEach(add);
  } else if (typeof product.image_urls === 'string') {
    try {
      const parsed = JSON.parse(product.image_urls);
      if (Array.isArray(parsed)) parsed.forEach(add);
    } catch (_) {
      product.image_urls.split(',').forEach((item) => add(item.trim()));
    }
  }

  extractImagesFromHtml(product.ext_content).forEach(add);
  return images;
};
